import * as React from 'react';
import { IframeWithErrorHandling } from '@app/components/IframeWithErrorHandling';

const eventsURL = (globalThis as any).eventsURL || './events/';

export const EventsHost: React.FC = () => <IframeWithErrorHandling src={eventsURL} title="eventsWindow" />;
